module.exports = __webpack_public_path__ + "static/media/beef7.95708d5e.jpg";